import { AuditEntity, ISyncable } from "@app/common";
import { SyncSchedule, TotalPrice } from "@app/core";
import { Customer } from "@app/customers-base";
import { BillSource } from "@app/products-base";
import { Column, Common, Display, prop, propObject, required, Table } from "@messaia/cdk";
import { BillStatus } from "../enums/bill-status";
import { BillItem } from "./bill-item";

@Table({
    endpoint: 'bill',
    includes: ['Customer', 'Client']
})
export class Bill extends AuditEntity implements ISyncable {
    @required()
    @Column({ name: 'customer.displayName', filter: 'customer.displayName' })
    @Display($localize`:@@customer:Customer`)
    customerId: number | null;
    customer: Customer;

    @required()
    @Column({ name: 'client.name', endpoint: 'client?enabled=true&projection=id,name', maxWidth: 200, showGtXl: true })
    @Display($localize`:@@client:Client`)
    clientId: number;

    @required()
    @Column({ enumType: BillSource, maxWidth: 85, showGtMd: true })
    @Display($localize`:@@source:Source`)
    source: BillSource = BillSource.Intern;

    @required()
    @Column({ width: 80, showGtLg: true })
    @Display($localize`:@@year:Year`)
    billYear: number;

    @required()
    @Column({
        content: (row: Bill) => Common.months?.filter(x => x.id == row.billMonth)[0]?.name,
        options: Common.months,
        width: 80,
        showGtLg: true
    })
    @Display($localize`:@@month:Month`)
    billMonth: number;

    @required()
    @Display($localize`:@@billDate:Bill date`)
    billDate: Date = new Date();

    @Display($localize`:@@total:Total`)
    @required()
    @propObject(TotalPrice)
    total: TotalPrice = new TotalPrice();

    @required()
    @Column({ enumType: BillStatus, maxWidth: 80, showGtLg: true })
    @Display($localize`:@@status:Status`)
    status: BillStatus = BillStatus.Created;

    @Column({ width: 115, showGtLg: true })
    @Display($localize`:@@bundleId:Bill bundle ID`)
    bundleId: number;

    @Column({ width: 70, showGtLg: true })
    @Display($localize`:@@version:Version`)
    billVersion: number;

    @Column({ filterOperator: '~', width: 90, showGtXl: true })
    @Display($localize`:@@number:Number`)
    number: number;

    @Display($localize`:@@notice:Notice`)
    @prop()
    notice: string;

    name: string;
    path: string;
    itemizedBillPath: string;
    tariffName: string;
    recreateAndSendPdf: boolean;
    items: BillItem[];
    syncSchedules: SyncSchedule[];

    /**
     * constructor
     * @param init 
     */
    public constructor(init?: Partial<Bill>) {
        super(init)
        Object.assign(this, init);

        if (!this.id) {
            /* Get current date */
            var currentDate = new Date();

            /* Substract one month */
            currentDate.setMonth(currentDate.getMonth() - 1);

            /* Set bill year and month */
            this.billYear = currentDate.getFullYear();
            this.billMonth = currentDate.getMonth() + 1;
        }
    }
}